import { render, staticRenderFns } from "./DealerModule.vue?vue&type=template&id=105d5000"
import script from "./DealerModule.vue?vue&type=script&lang=js"
export * from "./DealerModule.vue?vue&type=script&lang=js"
import style0 from "./DealerModule.vue?vue&type=style&index=0&id=105d5000&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_css-load_72a858df71aeaca8538e59a65db64572/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports